export default
{
    metryTable:
    {
        totalRows: "{rows} filas totales",
        selectedRows: "{rows} filas seleccionadas",
        oneSelectedRow: "1 fila seleccionadas",
        tableMenu: "Menú de la Mesa",
        columns: "Columnas",
        close: "Cerrar",
        noRowsToShow: "No Hay Filas Para Mostrar"
    }
}

